import { render, staticRenderFns } from "./PainDataChart.vue?vue&type=template&id=1e1cb254&scoped=true"
import script from "./PainDataChart.vue?vue&type=script&lang=js"
export * from "./PainDataChart.vue?vue&type=script&lang=js"
import style0 from "./PainDataChart.vue?vue&type=style&index=0&id=1e1cb254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1cb254",
  null
  
)

export default component.exports